import React from "react";
import Modal from "ReactComponents/Modal/modal";
import LoadSpinner from "ReactComponents/Shared/AnimationComponents/load-spinner";

function ModalSpinner(props) {
    return (
        <Modal isOpen={props.isOpen} notCloseable={props.isOpen}>
            <div className="u-text-align-center">
                <LoadSpinner />
            </div>
        </Modal>
    );
}

export default ModalSpinner;
